import { type AreaListInput, type LatLng } from '@terros/common'

const POINT_PADDING_DEGREES = 0.0005

/** A small search box around a property, split when it crosses the antimeridian. */
export const toAreaRunInputs = ({ latitude, longitude }: LatLng): AreaListInput[] => {
  const west = longitude - POINT_PADDING_DEGREES
  const east = longitude + POINT_PADDING_DEGREES
  const ranges = [{ west: Math.max(-180, west), east: Math.min(180, east) }]
  if (west < -180) ranges.push({ west: west + 360, east: 180 })
  if (east > 180) ranges.push({ west: -180, east: east - 360 })
  return ranges.map((range) => ({
    version: 2,
    archived: 'all',
    boundingBox: {
      top: { latitude: Math.min(90, latitude + POINT_PADDING_DEGREES), longitude: range.west },
      bottom: { latitude: Math.max(-90, latitude - POINT_PADDING_DEGREES), longitude: range.east },
    },
  }))
}
